module.exports = __webpack_public_path__ + "static/media/icone-download.3635f7ee.svg";